import {
  BudgetReportStateTypes,
  BudgetReportActionTypes,
} from "./BudgetReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BudgetReportStateTypes = {
  fetchAll: resetApiCallState([]),
};

const BudgetReportReducer = (
  state: BudgetReportStateTypes = INITIAL_STATE,
  action: any
): BudgetReportStateTypes => {
  switch (action.type) {
    case BudgetReportActionTypes.FETCH_ALL_BUDGET_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BudgetReportActionTypes.FETCH_ALL_BUDGET_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BudgetReportActionTypes.FETCH_ALL_BUDGET_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BudgetReportActionTypes.FETCH_ALL_BUDGET_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
    default:
      return state;
  }
};

export default BudgetReportReducer;
